import React from 'react';

// Vertical 10-segment LED pedal bar — fills bottom-to-top, label + pct beneath.
// Shared by the public rig page and the venue rig popup so both read identically.
export default function PedalBar({ label, value, color, glowRgba }) {
  const pct = value != null ? Math.max(0, Math.min(100, value)) : 0;
  const activeSegments = Math.round(pct / 10);
  return (
    <div className="flex flex-col items-center gap-2 w-full">
      {/* segments — reversed so index 0 is at the bottom */}
      <div className="flex flex-col-reverse gap-1 w-full">
        {Array.from({ length: 10 }).map((_, i) => {
          const lit = i < activeSegments;
          return (
            <div
              key={i}
              className="h-3 rounded-sm transition-all duration-100"
              style={lit
                ? { background: color, boxShadow: `0 0 8px ${glowRgba}` }
                : { background: '#262626' }
              }
            />
          );
        })}
      </div>
      {/* label + percentage */}
      <div className="flex flex-col items-center">
        <span className="text-white/70 text-[10px] font-mono font-bold tabular-nums">{Math.round(pct)}%</span>
        <span className="text-white/30 text-[9px] font-bold tracking-widest uppercase">{label}</span>
      </div>
    </div>
  );
}